import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'elastic-connectorpopup',
  templateUrl: './connectorpopup.component.html',
  styleUrls: ['./connectorpopup.component.scss']
})
export class ConnectorpopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
